import React, { createContext, useState } from 'react'

const defaultState = {
  ageGateSettings: {
    enabled: true,
    displayed: false,
    locking: false,
    usage: null
  },
  isLegalAge: false,
  countryCode: null,
  countryLegalAge: 18,
  formSubmitted: false,
  gameRating: null,
}
export const GeolocalizationContext = createContext(defaultState)

const GeolocalizationContextProvider = props => {
  const [ageGateSettings, setAgeGateSettings] = useState({
    enabled: true,
    displayed: props.pageGating ? props.pageGating : false,
    locking: props.pageGating ? props.pageGating : false,
    usage: props.pageGating ? 'globalPageGate' : null
  })
  const [isLegalAge, setLegalAge] = useState(false)
  const [countryCode, setCountryCode] = useState(null)
  const [countryLegalAge, setCountryLegalAge] = useState(null)
  const [formSubmitted, setFormSubmitted] = useState(false)
  const [gameRating, setGameRating] = useState(null)

  return (
    <GeolocalizationContext.Provider value={{
      ageGate: [ageGateSettings, setAgeGateSettings],
      legalAge: [isLegalAge, setLegalAge],
      currentCountryCode: [countryCode, setCountryCode],
      currentLegalAge: [countryLegalAge, setCountryLegalAge],
      formSubmit: [formSubmitted, setFormSubmitted],
      rating: [gameRating, setGameRating]
    }}>
      {props.children}
    </GeolocalizationContext.Provider>
  )
}

export default GeolocalizationContextProvider
